import $ from "jquery"
import {isResponsiveMD, isResponsiveSM, isResponsiveXS, prefix } from "./globals/index";
let toggleNews = false,
    toggleSocial = false;

class ArticleStickySideBar {

    constructor() {
        const self = this;
        this.init();
        this.showStickySideBar();
        this.stickBtnsToToggleSlides();
        this.hideSocialIcons;

        $(window).resize(function ()
        {
            // Don't reset social bar on mobile
            if (!isResponsiveSM()) {
                self.init();
                self.showStickySideBar();
                self.stickBtnsToToggleSlides();
                self.hideSocialIcons;
            }
        });
    }

    init() {
        const articleBody = $(`.${prefix}-article-body-section`);

        if (isResponsiveSM() || isResponsiveXS() || isResponsiveMD()) {

            const stickySideBar = $(`.${prefix}-sitcky-sidebar`),
                stickySocialIcons = $(`.${prefix}-article-sticky-social-icons`);
            stickySideBar.hide();
            stickySocialIcons.hide();

            const articleTitle = $(`#${prefix}-article-title h4`).text();

            // Show the bottom sticky buttons
            stickySocialIcons.length > 0 ? articleBody.append(`<div><button class="article-sticky-button share-button" id="showSocialIconsBtn">Share this article</button></div>`) : "";
            articleBody.append(`<div><button class="article-sticky-button" id="showRelatedNewsBtn">${articleTitle.length > 0  ? articleTitle : "Related News"}</button></div>`);

            $(`.${prefix}-sitcky-sidebar .vce-text-block h4`).hide();
            $(`.${prefix}-article-sticky-social-icons .vce-text-block`).hide();
            $(`.vce-col-content`).attr("style", "padding-top:0px");

            // Append the buttons that hide/show the menu while slideUp
            stickySideBar.prepend(`<div class="related-news-group-btn" style="${stickySocialIcons.length > 0 ? "" : "padding-top: 40px;"}">
            ${stickySocialIcons.length > 0 ? `<button class="social-icon-news-btn" id="socialIconsNewsStick">Share this Article</button>` : ""}
           <button class="related-news-btn" id="relatedNewsStick">Close ${articleTitle.length > 0  ? articleTitle : "Related News"}</button></div>`);
            stickySocialIcons.prepend(`<div class="related-news-group-btn"><button class="social-icon-news-btn" id="socialIconsStick">Share this Article</button></div>`);
        }
    }

    showStickySideBar() {
        const stickySideBar = $(`.${prefix}-sitcky-sidebar`),
            stickySocialIcons = $(`.${prefix}-article-sticky-social-icons`),
            $self = this;

        $("#showRelatedNewsBtn").click(function () {
            let showIcons = false;
            if (toggleSocial) {
                stickySocialIcons.slideToggle("slow"); // Hide
                toggleNews = false;
                toggleSocial = false;
                showIcons = true;
            }

            if (!toggleNews && !toggleSocial) {
                stickySideBar.slideToggle("slow"); // Show
                $(`.single`).attr("style", "overflow:hidden");
                $(`.page`).attr("style", "overflow:hidden");
                $(`.vcv-header`).slideToggle("fast")

                showIcons ? "" : $("#showSocialIconsBtn").slideToggle("slow");// show
                $(this).slideToggle("slow");// Hide
                toggleNews = true;
                toggleSocial = false;
            }
        });

        $("#showSocialIconsBtn").click(function () {
            if (!toggleNews && !toggleSocial) {
                stickySocialIcons.slideToggle("slow"); // Show
                $(this).slideToggle("slow");// Hide
                toggleNews = false;
                toggleSocial = true;
            }
        });
    }

    stickBtnsToToggleSlides() {
        $("#relatedNewsStick").click(function () {
            const stickySideBar = $(`.${prefix}-sitcky-sidebar`);

            stickySideBar.slideToggle("slow"); // Hode
            $(`.single`).attr("style", "overflow:scroll");
            $(`.page`).attr("style", "overflow:scroll");
            $("#showSocialIconsBtn").slideToggle("slow"); // Show

            // This is used in order to give the news menu more time
            setTimeout(function () {
                $(`.vcv-header`).slideToggle("slow")
            }, 200);

            $("#showRelatedNewsBtn").slideToggle("fast");// Show
            toggleNews = false;
        });

        $("#socialIconsNewsStick").click(function () {
            const stickySideBar = $(`.${prefix}-sitcky-sidebar`),
                stickySocialIcons = $(`.${prefix}-article-sticky-social-icons`);

            stickySocialIcons.slideToggle("slow");// Hide
            stickySideBar.slideToggle("slow");// Show

            $(`.single`).attr("style", "overflow:scroll");
            $(`.page`).attr("style", "overflow:scroll");

            $(`.vcv-header`).slideToggle("slow")

            toggleNews = false;
            $("#showRelatedNewsBtn").slideToggle("fast"); // Show
            toggleSocial = true;
            $("#showSocialIconsBtn").hide("slow"); // Show
        });

        const $self = this;
        $("#socialIconsStick").click(function () {
            $self.hideSocialIcons(true)
        });
    }

    hideSocialIcons(showSIBtn) {
        const stickySocialIcons = $(`.${prefix}-article-sticky-social-icons`);

        $(`.single`).attr("style", "overflow:scroll");
        $(`.page`).attr("style", "overflow:scroll");
        stickySocialIcons.slideToggle("slow"); // Hide
        $("#showSocialIconsBtn").slideToggle("slow"); // Show
        toggleSocial = false;
    }
}

export default ArticleStickySideBar;